export function resolveFirebaseAppCheckConfig(source = process.env) {
  const siteKey = String(
    source.REACT_APP_FIREBASE_APPCHECK_RECAPTCHA_ENTERPRISE_SITE_KEY || '',
  ).trim();
  const debugToken = String(
    source.REACT_APP_FIREBASE_APPCHECK_DEBUG_TOKEN || '',
  ).trim();
  const nodeEnv = String(source.NODE_ENV || '').trim().toLowerCase();
  return {
    debugToken: nodeEnv === 'production' ? '' : debugToken,
    enabled: siteKey.length >= 16,
    siteKey,
  };
}

export function installFirebaseAppCheckDebugToken(globalScope, debugToken) {
  if (!globalScope || !debugToken) return false;
  globalScope.FIREBASE_APPCHECK_DEBUG_TOKEN = debugToken;
  return true;
}
